const UserIcon = ({ stroke, ...props }) => (
  <svg width="64" height="65" viewBox="0 0 64 65" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M25.5774 40.916C35.4147 40.916 43.8227 42.4067 43.8227 48.3613C43.8227 54.316 35.4707 55.8494 25.5774 55.8494C15.7374 55.8494 7.33203 54.372 7.33203 48.4147C7.33203 42.4573 15.6814 40.916 25.5774 40.916Z"
      stroke="#2E3860"
      strokeWidth="4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M25.5778 32.4179C19.1192 32.4179 13.8818 27.1833 13.8818 20.7246C13.8818 14.2659 19.1192 9.03125 25.5778 9.03125C32.0338 9.03125 37.2712 14.2659 37.2712 20.7246C37.2952 27.1593 32.0952 32.3939 25.6605 32.4179H25.5778Z"
      stroke="#2E3860"
      strokeWidth="4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M43.9551 29.3833C48.2244 28.7833 51.5124 25.1193 51.5204 20.6846C51.5204 16.314 48.3337 12.6873 44.1551 12.002"
      stroke="#2E3860"
      strokeWidth="4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M49.5879 39.6504C53.7239 40.2664 56.6119 41.7171 56.6119 44.7037C56.6119 46.7597 55.2519 48.0931 53.0546 48.9277"
      stroke="#2E3860"
      strokeWidth="4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default UserIcon;
